import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import * as ScreenOrientation from 'expo-screen-orientation';
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { FormattedMessage } from 'react-intl';

import Button from '../../components/Button';
import InputDefault from "../../components/Form/InputDefault";

import styles from './styles';

const BarCodeConfirmPay = () => {
    const navigation = useNavigation();
    const [barCode, setBarCode] = useState('');

    async function goBack(){
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE_RIGHT);
        navigation.goBack();
    }

    return (
        <>
            <View style={styles.containerHeader}>
            <View style={styles.contentHeader}>
                <MaterialIcons
                    name="keyboard-arrow-left"
                    size={30}
                    color="#fff"
                    style={styles.iconsHeader}
                    onPress={goBack}
                />

                <Text style={styles.titleHeader}><FormattedMessage id='barCodeConfirmPay.CodigoBarras'/></Text>
            </View>
        </View>

            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <FormattedMessage id='barCodeConfirmPay.placeholderCodigoBarras'>
                        {placeholder =>
                    <InputDefault
                        value={barCode}
                        onValueChange={(value) => setBarCode(value)}
                        placeholder={placeholder}
                    />}
                    </FormattedMessage>
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='barCodeConfirmPay.txtValorPagamento'/></Text>
                    <Text><FormattedMessage id='barCodeConfirmPay.txtValorPagamentoBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='barCodeConfirmPay.txtMoeda'/></Text>
                    <Text><FormattedMessage id='barCodeConfirmPay.txtGpxToken'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='barCodeConfirmPay.txtValorDoDia'/></Text>
                    <Text><FormattedMessage id='barCodeConfirmPay.txtValorDoDiaGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='barCodeConfirmPay.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='barCodeConfirmPay.txtNome'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='barCodeConfirmPay.btnConfimar'/>} titlePage={<FormattedMessage id='barCodeConfirmPay.btnConfimaPagamento'/>} />
        </>
    );
}

export default BarCodeConfirmPay;